import {Component, OnInit} from '@angular/core';

import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

export interface IStopTestConfig {
  title: string;
  text: string;
  continueText: string;
  stopText: string;
}

@Component({
  selector: 'lib-stop-test-confirmation-modal',
  templateUrl: './stop-test-confirmation-modal.component.html',
  styleUrls: ['./stop-test-confirmation-modal.component.scss']
})
export class StopTestConfirmationModalComponent implements OnInit {
  clickCount = 0;
  isEng = false;
  config: IStopTestConfig = {
    title: 'Are you sure you want to suspend the test?',
    text: 'If you want to suspend the test &mdash; no payment will be charged, and you will be redirected to the main page.',
    continueText: 'Proceed',
    stopText: 'Suspend',
  };

  constructor(
    public activeModal: NgbActiveModal
  ) {
  }

  ngOnInit(): void {
  }

  onStop() {
    this.activeModal.close(true);
  }

  onContinue() {
    this.activeModal.close(false);
  }

  onGoToQ() {
    this.activeModal.close('goToQ');
  }

  dc() {
    this.clickCount++;
    setTimeout(() => {
      if (this.clickCount === 1) {
      } else if (this.clickCount === 2) {
        this.onGoToQ();
      }
      this.clickCount = 0;
    }, 250);
  }
}
